import React from 'react';
import { Grid } from 'react-bootstrap';

import DashboardHero from 'components/ClientATS/Dashboard/DashboardHero';

import styles from './Dashboard.module.scss';

const Dashboard = () => {
  return (
    <Grid className={styles.wrapper}>
      <DashboardHero />
      <header className={styles.pageHeader}>
        <h2 className={styles.pageTitle}>Job Dashboard</h2>
        <p className={styles.pageDescription}>
          Manage your active postings, review past positions, and explore your
          talent pool
        </p>
      </header>
    </Grid>
  );
};

export default Dashboard;
